import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { BottomSheet } from "sprout-ui-dom/dist/BottomSheet";
import { usePostPageEditor } from "../PostPageEditorContext";
import useUpdateComment from "../graphql/mutations/useUpdateComment";
import useCreateComment from "../graphql/mutations/useCreateComment";
import PostPageCommentEditorDesktop from "./PostPageCommentEditorDesktop";
import PostPageCommentEditorMobile from "./PostPageCommentEditorMobile";
import { saveToLocalStorage } from "./utils";
const PostPageCommentEditor = (props)=>{
    const { itemId , cacheKey , open , desktopMt , desktopMb , desktopPt , comment , desktopVariant , parentItem ,  } = props;
    const { dispatch  } = usePostPageEditor();
    const closeEditor = useCallback(()=>{
        dispatch({
            type: "CLOSE_EDITOR"
        });
    }, [
        dispatch
    ]);
    const handleCancel = useCallback(()=>{
        closeEditor();
        saveToLocalStorage.cancel();
        if (localStorage) localStorage.removeItem(cacheKey);
    }, [
        cacheKey,
        closeEditor
    ]);
    const updateComment = useUpdateComment();
    const createComment = useCreateComment();
    const onUpdateOrCreate = useCallback((content)=>{
        if (!content) return;
        // If comment exists, it's an update
        if (comment) {
            const { text , id , nodeId  } = comment;
            /**
         * EDITOR_TODO: We need a parser for the `getText()` output from `tiptap`,
         * So that we can render the `PostPageComment` content correctly from `text`.
         */ if (text !== content) updateComment({
                id,
                nodeId,
                text: content
            });
        } else if (parentItem) {
            if (parentItem.__typename === "Comment") createComment({
                parentCommentNodeId: parentItem.nodeId,
                parentCommentId: parentItem.id,
                text: content
            });
            else createComment({
                parentItemNodeId: parentItem.nodeId,
                parentItemId: parentItem.id,
                text: content
            });
        }
        handleCancel();
    }, [
        comment,
        createComment,
        handleCancel,
        parentItem,
        updateComment
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BottomSheet, {
                open: open === "mobile",
                unmountOnExit: true,
                children: /*#__PURE__*/ _jsx(PostPageCommentEditorMobile, {
                    itemId: itemId,
                    cacheKey: cacheKey,
                    onUpdateOrCreate: onUpdateOrCreate,
                    closeEditor: closeEditor,
                    comment: comment
                })
            }),
            open === "desktop" && /*#__PURE__*/ _jsx(PostPageCommentEditorDesktop, {
                itemId: itemId,
                cacheKey: cacheKey,
                desktopMb: desktopMb,
                desktopPt: desktopPt,
                desktopMt: desktopMt,
                comment: comment,
                desktopVariant: desktopVariant,
                onUpdateOrCreate: onUpdateOrCreate,
                onCancel: handleCancel
            })
        ]
    });
};
export default PostPageCommentEditor;
